import { lazy, Suspense, useEffect, useState, useRef } from "react";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import Loader from "../component/Loading";
import { Link, useLocation, useNavigate } from "react-router-dom";
import StarIcon from "@mui/icons-material/Star";
import Toaster from "../component/Toaster";
import api from "../constants/API";
import { FormateDate } from "../utils/FormateDate";
import { Title } from "./styles";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import BreadCrumb from "../component/BreadCrumb";
import ExamPageStructuredData from "../richSnippets/ExamPageStructuredData";
import { Helmet } from "react-helmet";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import PreorderProduct from "./PreorderProduct";
import { ExamDetailsSkeleton } from "./ExamDetailsSkeleton";
import { SiteId } from "../constants/constants";
import { styled } from "@mui/system";
import Card from "@mui/material/Card";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import CardContent from "@mui/material/CardContent";
import Chip from "@mui/material/Chip";
import Collapse from "@mui/material/Collapse";
import Divider from "@mui/material/Divider";
import Grid from "@mui/material/Grid";
import LinearProgress from "@mui/material/LinearProgress";
import Rating from "@mui/material/Rating";
import Tooltip from "@mui/material/Tooltip";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import InfoIcon from "@mui/icons-material/Info";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import UpdateIcon from "@mui/icons-material/Update";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
const ExamDiscussion = lazy(() => import("./ExamDiscussion"));
const UnavailableExam404 = lazy(() => import("./UnavailableExam404"));

const TargetBox = lazy(() => import("./TargetBox"));
const StyledCard = styled(Card)(({ theme }) => ({
  borderRadius: "20px",
  boxShadow: "0 10px 30px rgba(0, 0, 0, 0.1)",
  overflow: "visible",
  position: "relative",
  background: "linear-gradient(145deg, #ffffff, #f0f0f0)",
}));

const ActionButton = styled(Button)(({ theme }) => ({
  color: "#fff",
  fontWeight: 600,
  padding: "12px 24px",
  borderRadius: "30px",
  fontSize: "1rem",
  textTransform: "none",
  transition: "all 0.3s ease",
  "&:hover": {
    backgroundColor: "#FFD500",
    transform: "translateY(-3px)",
  },
}));

const InfoBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginBottom: theme.spacing(2),
  padding: theme.spacing(2),
  borderRadius: "10px",
  backgroundColor: "rgba(39, 177, 187, 0.1)",
}));

const ProgressBar = styled(LinearProgress)(({ theme }) => ({
  height: 10,
  borderRadius: 5,
  backgroundColor: "rgba(39, 177, 187, 0.2)",
  "& .MuiLinearProgress-bar": {
    borderRadius: 5,
    backgroundColor: "#27B1BB",
  },
}));
const StickyHeader = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  padding: theme.spacing(2),
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  borderBottom: "1px solid rgba(0, 0, 0, 0.12)",
}));
const PriceChip = styled(Box)(({ theme }) => ({
  backgroundColor: "#27B1BB",
  color: "#fff",
  fontWeight: "bold",
  fontSize: "1.5rem",
  padding: "16px",
  borderRadius: "16px",
  boxShadow: "0 4px 10px rgba(39, 177, 187, 0.3)",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
}));

function ExamPage() {
  const location = useLocation();
  const { pathname } = location;
  const pathspilt = pathname.split("/");
  const ExamCode = pathspilt[2];
  const ExamVendor = decodeURIComponent(pathspilt[1].replace(/-/g, "%20"));
  const navigate = useNavigate();
  const [exam, setExam] = useState("");
  const [demoExam, setDemoExam] = useState({});
  const [examId, setExamId] = useState();
  const [subject, setSubject] = useState([]);
  const [selected, setSelected] = useState([]);
  const [correctOptions, setCorrectOptions] = useState([]);
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(true); // change back to false
  const [showResults, setShowResults] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [currentQuestionRating, setCurrentQuestionRating] = useState({});
  const [examText, setExamText] = useState("");
  const [showDemoQuestions, setShowDemoQuestions] = useState(false);
  const [demoLoading, setDemoLoading] = useState(false);
  const [initiatePdf, setInitiatePdf] = useState(null);
  const [isSticky, setIsSticky] = useState(false);
  const priceRef = useRef(null);
  const [showSubjects, setShowSubjects] = useState(true);

  const totalQuestions = demoExam?.CustomTotalQuestions || 0;
  const getPercentage = (count) => (count / totalQuestions) * 100;

  const handleScroll = () => {
    if (priceRef.current) {
      const rect = priceRef.current.getBoundingClientRect();
      setIsSticky(rect.top < 0);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const toggleShowDemoQuestions = async () => {
    localStorage.removeItem("passingPercentage");
    setDemoLoading(true); // Show the loading indicator
    await getExam();
    // setShowDemoQuestions(true);
    setShowDemoQuestions((prev) => {
      const nextVal = !prev;
      if (!prev) {
        setTimeout(() => {
          window.scrollTo({
            top: buttonRef.current?.offsetTop + 700,
            behavior: "smooth",
          });
        }, 300);
      }
      return nextVal;
    });
    setDemoLoading(false); // Hide the loading indicator
  };
  const resetState = () => {
    setShowDemoQuestions(false);
  };

  const [alert, setAlert] = useState({
    open: false,
    type: "info",
    text: "",
  });
  const [currentExamRating, setCurrentExamRating] = useState(null);
  const [initialComments, setInitialComments] = useState([]);
  const [isExpired, setIsExpired] = useState(false);
  const [newExam, setNewExam] = useState("");
  const [totalQuestion, settotalQuestion] = useState(null);
  const [singleSelectTotal, setSingleSelectTotal] = useState(0);
  const [multiSelectTotal, setMultiSelectTotal] = useState(0);
  const [hotspotTotal, setHotspotTotal] = useState(0);
  const [dragdropTotal, setDragdropTotal] = useState(0);
  const [orderlistTotal, setorderlistTotal] = useState(0);
  const [fillintheblanksTotal, setfillintheblanksTotal] = useState(0);
  const [availableItems, setAvailableItems] = useState([]);
  const [answerItems, setAnswerItems] = useState([]);
  const [pdfDownloadableQuestions, setPdfDownloadableQuestions] = useState(2);
  const buttonRef = useRef(null);
  const buttonRef2 = useRef(null);
  const refs = [buttonRef, buttonRef2];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate");
          } else {
            entry.target.classList.remove("animate");
          }
        });
      },
      { threshold: 0.5 } // Adjust the threshold as needed
    );

    refs.forEach((ref) => {
      if (ref.current) {
        observer.observe(ref.current);
      }
    });

    return () => {
      refs.forEach((ref) => {
        if (ref.current) {
          observer.unobserve(ref.current);
        }
      });
    };
  }, [refs]);

  const getUserRating = async () => {
    setDemoLoading(true);
    try {
      const { data } = await api.get(
        `api/rating/${demoExam.ExamId}/${Question().QuestionId}/${SiteId}`
      );
      setDemoLoading(false);
      setCurrentQuestionRating(data);
    } catch (err) {
      setDemoLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    getData();
    resetState();
  }, [ExamCode]);
  useEffect(() => {
    if (Question().QuestionId) getUserRating();
  }, [exam]);
  useEffect(() => {
    if (Question().QuestionId) {
      getUserRating();
    }
  }, [currentQuestion]);

  const priceData = [
    {
      Id: 1,
      PriceDesc: "PDF Printable (Q & A)",
      ExamDiscount: 0,
      ExamPrice: 39,
      OrderLevel: 1,
    },
    {
      Id: 2,
      PriceDesc: "Practice Test (Web Based)",
      ExamDiscount: 0,
      ExamPrice: 49,
      OrderLevel: 2,
    },
    {
      Id: 3,
      PriceDesc: "Bundle Pack",
      ExamDiscount: 40,
      ExamPrice: 59,
      OrderLevel: 3,
    },
    {
      Id: 1002,
      PriceDesc: "All Exams Bundle",
      ExamDiscount: 40,
      ExamPrice: 300,
      OrderLevel: 4,
    },
  ];

  const examPrice =
    demoExam.PDFPrice !== 0 ? demoExam.PDFPrice : priceData[0].ExamPrice;
  const originalPrice = examPrice >= 150 ? 300 : 70;

  const getData = async () => {
    setLoading(true);
    setExam("");
    setShow(false);
    setShowResults(false);
    setCorrectOptions([]);
    setSelected([]);
    setAnswerItems([]);
    setAvailableItems([]);
    setDemoExam({});
    setSubject([]);
    setCurrentQuestion(0);
    setCurrentQuestionRating({});
    await getCurrentExam();
    setLoading(false);
  };
  const getCurrentExam = async () => {
    try {
      const { data } = await api.get(
        `api/exam/GetExambyCode?ExamCode=${ExamCode}&SiteId=${SiteId}`
      );
      setIsExpired(data.Items[0].IsExpired);
      setNewExam(data.Items[0].ExamRefference);
      setDemoExam(data.Items[0]);
      setInitialComments(data.Comments);
      setExamId(data.Items[0].ExamId);
      const subjectNames = data.Subjects?.map((item) => item.SubjectName);
      setSubject(subjectNames);
      setCurrentExamRating(data.Items[0]);
      let questions = data.Items[0].TotalQuestions;
      settotalQuestion(questions);
      let singleSelectTotal = data.Items[0].SingleSelectQuestions;
      let multiSelectTotal = data.Items[0].MultiSelectQuestions;
      let hotspotTotal = data.Items[0].HOTSPOTQuestions;
      let dragdropTotal = data.Items[0].DRAGDROPQuestions;
      let orderlistTotal = data.Items[0].ORDERLISTQuestions;
      let fillintheblanksTotal = data.Items[0].FILLINTHEBLANKSQuestions;
      settotalQuestion(questions);
      setSingleSelectTotal(singleSelectTotal);
      setMultiSelectTotal(multiSelectTotal);
      setHotspotTotal(hotspotTotal);
      setDragdropTotal(dragdropTotal);
      setorderlistTotal(orderlistTotal);
      setfillintheblanksTotal(fillintheblanksTotal);
      setPdfDownloadableQuestions(questions);
      sessionStorage.setItem("currentExameId", data.Items[0].ExamId);

      // Update ExamPrice based on Id
      const updatedPriceData = priceData.map((item) => {
        switch (item.Id) {
          case 1:
            item.ExamPrice = data.Items[0].PDFPrice; // assuming PDFPrice is available
            break;
          case 2:
            item.ExamPrice = data.Items[0].PractisePrice; // assuming PractisePrice is available
            break;
          case 3:
            item.ExamPrice = data.Items[0].BundlePrice; // assuming BundlePrice is available
            break;

          default:
            break;
        }
        return item;
      });
      if (
        data.Items[0].PDFPrice !== 0 &&
        data.Items[0].PractisePrice !== 0 &&
        data.Items[0].BundlePrice !== 0
      ) {
        sessionStorage.setItem(
          "updatedPriceData",
          JSON.stringify(updatedPriceData)
        );
      }

      // Set the examText here using the fetched data
      if (data.Items[0].IsPreOrder) {
        setExamText(`
          <p>Coming Soon: ${data.Items[0]?.ExamCode} Real Exam Questions and Online Practice Test Engine by DirectCertify. Be among the first to access our comprehensive ${data.Items[0]?.ExamCode} exam preparation materials!</p>
          <p>As a special offer for our early supporters, preorder customers will get full access to all the latest ${data.Items[0]?.ExamCode} questions as soon as they become available. Reserve your spot today and supercharge your exam preparation!</p>
        `);
      } else {
        setExamText(`<p>
          ${data.Items[0]?.ExamCode} real exam questions and online practice test engine by DirectCertify.
          Try ${data.Items[0]?.ExamCode} exam questions for free. 
          You can also download a free demo of the ${data.Items[0]?.ExamCode} exam PDF.
          If you like our product, you can request full access to all the latest ${data.Items[0]?.ExamCode} questions.</p>
        `);
      }
    } catch (err) {
      navigate("/error");
      console.log(err);
    }
  };

  useEffect(() => {
    localStorage.setItem("Rating", demoExam?.Rating);
    localStorage.setItem("RatingCount", demoExam?.Count);
  }, [demoExam]);

  const getExam = async () => {
    try {
      let noOfQuestion = pdfDownloadableQuestions;
      if (noOfQuestion <= 20) {
        noOfQuestion = 2;
      } else {
        noOfQuestion = 5;
      }
      const id = sessionStorage.getItem("currentExameId");
      let { data } = await api.get(`api/Exam/GetDemoQuestions_updated/${id}/5`);
      // Assuming setExam and setStructuredData are state-setting functions
      setExam(data[0]);
    } catch (err) {
      console.error(err); // Changed console.log to console.error for better error visibility
    }
  };
  const handleInitiateDownload = async () => {
    setDemoLoading(true);
    if (!initiatePdf) {
      const module = await import("../utils/pdfDownloader");
      const initiatePdfFunction = module.handleDownloadPdf;
      setInitiatePdf(() => initiatePdfFunction);
      await initiatePdfFunction(
        examId,
        pdfDownloadableQuestions,
        setDemoLoading
      );
    } else {
      await initiatePdf(examId, pdfDownloadableQuestions, setDemoLoading);
    }
    setDemoLoading(false);
  };

  const alertToggle = () => {
    setAlert({
      open: false,
      text: "",
      type: "info",
    });
  };

  useEffect(() => {
    const options = Question().examDemoOptionDto || [];

    // Check if options have values
    if (options.length > 0) {
      // Extract all available items from options and save them in state
      const allAvailableItems = options.reduce((accumulator, option) => {
        const items = Array.isArray(option.CHOICETEXT)
          ? option.CHOICETEXT
          : [option.CHOICETEXT];
        return [...accumulator, ...items];
      }, []);
      setAvailableItems(allAvailableItems);
    }
  }, [exam, currentQuestion]);

  const Question = () => {
    if (exam.examDemoQuestionDto) {
      return exam.examDemoQuestionDto[currentQuestion];
    } else {
      return {};
    }
  };

  const originalPath = demoExam?.ExamVendorName;
  const encodedPath = encodeURIComponent(originalPath);
  const ExamVendorName = encodedPath.replace(/%20/g, "-");

  let title = `${demoExam?.ExamCode} Practice Test Questions Answers` ?? "";
  let metaDesc = demoExam.SiteMetaDescription
    ? demoExam?.SiteMetaDescription.replace(
        /\{%exam-code%\}/g,
        demoExam?.ExamCode
      )
        .replace(/\{%exam-name%\}/g, demoExam?.ExamName)
        .replace(/\{%category-name%\}/g, demoExam?.ExamVendorName)
    : `Unlock your success with DirectCertify's ${
        demoExam?.ExamCode || "Exam"
      } Questions Answers, Web-Based ${
        demoExam?.ExamCode || "Exam"
      } Practice Test, Prepare yourself in real exam scenario, and download PDF dumps.`;
  let sitePageContent = demoExam?.SitePageContent ?? "";
  let sitePageContent2 = demoExam?.SitePageContentChild ?? "";

  if (demoExam?.SitePageContent) {
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(
      demoExam.SitePageContent,
      "text/html"
    );
    const h1 = htmlDoc.querySelector("h1");

    if (h1) {
      title = h1.textContent;
    }
  }

  if (sitePageContent) {
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(sitePageContent, "text/html");
    const h1 = htmlDoc.querySelector("h1");

    if (h1) {
      title = h1.textContent;
      h1.remove();
    }

    const ulElements = htmlDoc.querySelectorAll("ul");
    ulElements.forEach((ul) => {
      ul.style.maxWidth = "max-content";
      ul.style.margin = "auto";
      ul.style.textAlign = "left";
    });

    const pElements = htmlDoc.querySelectorAll("p");
    pElements.forEach((p) => {
      p.style.marginTop = "10px";
      p.style.marginBottom = "10px";
      p.style.lineHeight = "130%";
    });

    sitePageContent = htmlDoc.body.innerHTML;
  }
  if (sitePageContent2) {
    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(sitePageContent2, "text/html");
    sitePageContent2 = htmlDoc.body.innerHTML;
  }
  const getContent = () => {
    if (sitePageContent) {
      return sitePageContent
        .replace(/\{%exam-code%\}/g, demoExam?.ExamCode)
        .replace(/\{%exam-name%\}/g, demoExam?.ExamName)
        .replace(/\{%category-name%\}/g, demoExam?.ExamVendorName);
    } else {
      return examText;
    }
  };
  if (loading) {
    return <ExamDetailsSkeleton />;
  }
  if (demoExam?.IsActive === false) {
    return <UnavailableExam404 demoExam={demoExam} title={title} />;
  }
  return (
    <>
      <Helmet>
        <title>
          {demoExam.SiteTitle
            ? demoExam?.SiteTitle.replace(
                /\{%exam-code%\}/g,
                demoExam?.ExamCode
              )
                .replace(/\{%exam-name%\}/g, demoExam?.ExamName)
                .replace(/\{%category-name%\}/g, demoExam?.ExamVendorName)
            : `Web-Based ${
                demoExam?.ExamCode || ""
              } Practice Test PDF Question Answers for Self-Learning`}
        </title>
        <meta name="description" content={metaDesc} />
      </Helmet>
      <Box sx={{ my: 10 }}>
        {demoExam && (
          <ExamPageStructuredData
            examName={demoExam.ExamName}
            vendor={ExamVendor}
            examCode={ExamCode}
            examDescription={metaDesc}
            ratingData={Number(demoExam.Rating)}
            ratingCount={parseInt(demoExam.Count, 10)}
            examPrice={examPrice.toString()}
          />
        )}
        {/* <Container> */}
        <Container sx={{ marginTop: { xs: "125px", md: "110px" } }}>
          <BreadCrumb text="Home" to="/" isLast={false} />
          <BreadCrumb
            text={demoExam?.ExamVendorName || ""}
            to={`/${(ExamVendorName || "").toLowerCase().replace(/%2b/g, "p")}`}
            isLast={false}
          />
          <BreadCrumb text={demoExam?.ExamCode || ""} to="" isLast={true} />
          <Title>{title}</Title>

          {/* </Box> */}
          {demoExam.IsPreOrder ? (
            <PreorderProduct
              examId={demoExam.ExamId}
              examName={demoExam.ExamName}
              examCode={demoExam.ExamCode}
              price={demoExam.PDFPrice}
            />
          ) : (
            <StyledCard>
              {isExpired && (
                <Box
                  sx={{
                    margin: "16px 0",
                  }}
                >
                  <Alert
                    severity="error"
                    icon={<InfoIcon sx={{ fontSize: "2.5rem" }} />}
                    sx={{
                      backgroundColor: "#FFF3E0",
                      border: "1px solid #ff4d4d",
                      "& .MuiAlert-icon": {
                        color: "#f50000",
                      },
                    }}
                  >
                    <AlertTitle
                      sx={{
                        fontSize: "1.2rem",
                        fontWeight: "bold",
                        color: "#e60000",
                      }}
                    >
                      Exam Retired!
                    </AlertTitle>
                    <Typography
                      variant="body1"
                      sx={{ color: "#424242", fontWeight: "medium" }}
                    >
                      This exam is no longer available.
                    </Typography>
                    {newExam && (
                      <Box sx={{ mt: 1 }}>
                        <Typography
                          variant="body1"
                          sx={{
                            color: "#424242",
                            display: "inline",
                            fontWeight: "medium",
                          }}
                        >
                          Please check the newer version:{" "}
                        </Typography>
                        <Link
                          to={`/${ExamVendorName.toLowerCase().replace(
                            /%2b/g,
                            "p"
                          )}/${newExam.toLowerCase()}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            color: "#1976D2",
                            fontWeight: "bold",
                            textDecoration: "none",
                            marginLeft: "2px",
                            fontSize: "1rem",
                            fontFamily: "inherit",
                          }}
                        >
                          {newExam}
                        </Link>
                      </Box>
                    )}
                  </Alert>
                </Box>
              )}
              <StickyHeader
                elevation={5}
                sx={{
                  borderRadius: "10px",
                  mb: 2,
                  // Arrange content side by side, then stack on mobile
                  display: "flex",
                  flexWrap: "wrap",
                  alignItems: "center",
                  justifyContent: "space-between",
                  "& > *": { mb: 1 },
                  // For mobile
                  "@media (max-width: 600px)": {
                    flexDirection: "column",
                    alignItems: "flex-start",
                  },
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    mb: { xs: 2, sm: 0 },
                  }}
                >
                  <Box sx={{ mr: 2 }}>
                    <Typography
                      variant="h5"
                      component="h2"
                      fontWeight="bold"
                      color="#27B1BB"
                    >
                      {demoExam?.ExamName}
                    </Typography>
                    <Typography
                      variant="subtitle1"
                      component="span"
                      fontWeight="bold"
                    >
                      Exam Code: {demoExam?.ExamCode}
                    </Typography>
                    <Box display="flex" alignItems="center">
                      <Rating
                        value={
                          currentExamRating?.Rating === 0
                            ? 5
                            : currentExamRating?.Rating
                        }
                        readOnly
                        precision={0.1}
                        sx={{ fontSize: "1.5rem" }}
                      />
                      <Typography
                        variant="span"
                        color="text.secondary"
                        ml={1}
                        sx={{ fontSize: "14px" }}
                      >
                        {(currentExamRating?.Rating === 0
                          ? 5
                          : currentExamRating?.Rating
                        ).toFixed(1)}{" "}
                        ({currentExamRating?.Count || 1})
                      </Typography>
                    </Box>
                  </Box>
                  {!isExpired && (
                    <PriceChip sx={{ ml: 0 }}>
                      <Typography
                        variant="span"
                        sx={{
                          textDecoration: "line-through",
                          opacity: 0.7,
                          fontWeight: "bold",
                        }}
                      >
                        ${originalPrice}
                      </Typography>
                      <Typography
                        variant="h4"
                        component="span"
                        fontWeight="bold"
                      >
                        ${examPrice}
                      </Typography>
                      <Typography
                        variant="body2"
                        sx={{
                          color: "#FFD700",
                          fontWeight: "bold",
                          textAlign: "center",
                        }}
                      >
                        Save{" "}
                        {((1 - examPrice / originalPrice) * 100).toFixed(0)}%
                      </Typography>
                    </PriceChip>
                  )}
                </Box>
                {!isExpired && (
                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      width: "100%",
                      // Stack buttons on mobile
                      "@media (max-width: 600px)": {
                        flexDirection: "column",
                        alignItems: "stretch",
                      },
                    }}
                  >
                    <ActionButton
                      component={Link}
                      to={`/product-detail/${(
                        demoExam?.ExamCode || ""
                      ).toLowerCase()}`}
                      state={demoExam}
                      startIcon={<ShoppingCartIcon />}
                      sx={{
                        background: "#FFD500",
                        color: "black",
                        mt: { xs: 0, sm: 1, md: 0 },
                        ml: { xs: 0, sm: 1 },
                        mb: { xs: 1, sm: 0 },
                        order: { xs: -1, sm: 3 },
                      }}
                    >
                      Add To Cart
                    </ActionButton>
                    {!showDemoQuestions && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={toggleShowDemoQuestions}
                        disabled={loading}
                        startIcon={
                          showDemoQuestions ? (
                            <KeyboardArrowUpIcon />
                          ) : (
                            <KeyboardArrowDownIcon />
                          )
                        }
                        sx={{
                          borderRadius: "30px",
                          background: "#27b1bb",
                          fontWeight: "600",
                          transition: "all 0.3s ease",

                          "&:hover": {
                            transform: "translateY(-3px)",
                            background: "#27b1bb",
                          },
                        }}
                      >
                        Try Sample Test
                      </Button>
                    )}
                    {/* <Button
                      ref={buttonRef}
                      variant="outlined"
                      onClick={handleInitiateDownload}
                      startIcon={<CloudDownloadIcon />}
                      sx={{
                        borderRadius: "30px",
                        color: "#27b1bb",
                        fontWeight: "600",
                        // transition: "ease",
                        transition: "all 0.3s ease",

                        ml: { xs: 0, sm: 1 },
                        mb: { xs: 1, sm: 0 },
                        "&:hover": {
                          transform: "translateY(-3px)",
                          borderColor: "#27b1bb",
                        },
                      }}
                    >
                      Download Demo
                    </Button> */}
                    <Box
                      sx={{
                        display: "flex",
                        flexWrap: "wrap",
                        gap: 1,
                        mt: { xs: 1, md: 0 },
                        justifyContent: "center",
                      }}
                    >
                      <Tooltip title="PDF Demo">
                        <Button
                          ref={buttonRef}
                          variant="outlined"
                          onClick={handleInitiateDownload}
                          startIcon={<CloudDownloadIcon />}
                          sx={{
                            borderRadius: "30px",
                            color: "#27b1bb",
                            fontWeight: "600",
                            transition: "all 0.3s ease",
                            ml: { xs: 0, sm: 1 },
                            // mb: { xs: 1, sm: 0 },
                            "&:hover": {
                              transform: "translateY(-3px)",
                              borderColor: "#27b1bb",
                            },
                          }}
                        >
                          Download PDF
                        </Button>
                      </Tooltip>

                      <Tooltip title="Interactive Practice Test Engine Demo">
                        <Button
                          variant="outlined"
                          onClick={() => {
                            // Add the download URL here
                            const downloadUrl = `https://directcertify.com/ExamAdmin/download?examCode=${ExamCode}`;
                            const link = document.createElement("a");
                            link.href = downloadUrl;
                            link.download = `${
                              demoExam?.ExamCode || "Demo"
                            }-Testing-Engine.exe`; // Set desired filename
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                          }}
                          startIcon={<CloudDownloadIcon />}
                          sx={{
                            borderRadius: "30px",
                            color: "#27b1bb",
                            fontWeight: "600",
                            transition: "all 0.3s ease",
                            "&:hover": {
                              transform: "translateY(-3px)",
                              borderColor: "#27b1bb",
                            },
                          }}
                        >
                          Demo Testing Engine
                        </Button>
                      </Tooltip>
                    </Box>
                  </Box>
                )}
              </StickyHeader>
              {!isExpired && (
                <CardContent>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                      <InfoBox>
                        <HelpOutlineIcon
                          sx={{ fontSize: 30, color: "#27B1BB", mr: 2 }}
                        />
                        <Box>
                          <Typography
                            variant="h6"
                            component="h3"
                            fontWeight="bold"
                          >
                            Total Questions
                          </Typography>
                          <Typography>
                            {demoExam?.CustomTotalQuestions}
                          </Typography>
                        </Box>
                      </InfoBox>
                      <InfoBox>
                        <AccessTimeIcon
                          sx={{ fontSize: 30, color: "#27B1BB", mr: 2 }}
                        />
                        <Box>
                          <Typography
                            variant="h6"
                            component="h3"
                            fontWeight="bold"
                          >
                            Duration
                          </Typography>
                          <Typography>
                            {demoExam?.ExamTimeInMinutes} Minutes
                          </Typography>
                        </Box>
                      </InfoBox>
                    </Grid>

                    <Grid item xs={12} md={6}>
                      {demoExam?.Date && (
                        <InfoBox>
                          <UpdateIcon
                            sx={{ fontSize: 30, color: "#27B1BB", mr: 2 }}
                          />
                          <Box>
                            <Typography
                              variant="h6"
                              component="h3"
                              fontWeight="bold"
                            >
                              Last Updated
                            </Typography>
                            <Typography>
                              {FormateDate(demoExam?.Date)}
                            </Typography>
                          </Box>
                        </InfoBox>
                      )}
                      {demoExam?.ExamVersion && (
                        <InfoBox>
                          <StarIcon
                            sx={{ fontSize: 30, color: "#27B1BB", mr: 2 }}
                          />
                          <Box>
                            <Typography
                              variant="h6"
                              component="h3"
                              fontWeight="bold"
                            >
                              Latest Version
                            </Typography>
                            <Typography>{demoExam?.ExamVersion}</Typography>
                          </Box>
                        </InfoBox>
                      )}
                    </Grid>

                    <Grid item xs={12}>
                      <Divider sx={{ my: 2 }} />
                    </Grid>

                    {demoExam?.CustomTotalQuestions ===
                      demoExam?.TotalQuestions && (
                      <Grid item xs={12}>
                        <Typography
                          variant="h6"
                          component="h3"
                          fontWeight="bold"
                          gutterBottom
                        >
                          Question Types
                        </Typography>
                        <Grid container spacing={2}>
                          {singleSelectTotal > 0 && (
                            <Grid item xs={12} sm={6} md={4}>
                              <Tooltip title="Single Choice Questions">
                                <Box>
                                  <Typography variant="body2" gutterBottom>
                                    Single Choice
                                  </Typography>
                                  <ProgressBar
                                    role="progressbar"
                                    aria-label="single choice questions"
                                    variant="determinate"
                                    value={getPercentage(singleSelectTotal)}
                                  />
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    align="right"
                                  >
                                    {singleSelectTotal}
                                  </Typography>
                                </Box>
                              </Tooltip>
                            </Grid>
                          )}
                          {multiSelectTotal > 0 && (
                            <Grid item xs={12} sm={6} md={4}>
                              <Tooltip title="Multiple Choice Questions">
                                <Box>
                                  <Typography variant="body2" gutterBottom>
                                    Multiple Choice
                                  </Typography>
                                  <ProgressBar
                                    role="progressbar"
                                    aria-label="multi choice questions"
                                    variant="determinate"
                                    value={getPercentage(multiSelectTotal)}
                                  />
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    align="right"
                                  >
                                    {multiSelectTotal}{" "}
                                  </Typography>
                                </Box>
                              </Tooltip>
                            </Grid>
                          )}
                          {hotspotTotal > 0 && (
                            <Grid item xs={12} sm={6} md={4}>
                              <Tooltip title="Hotspot Questions">
                                <Box>
                                  <Typography variant="body2" gutterBottom>
                                    Hotspot
                                  </Typography>
                                  <ProgressBar
                                    role="progressbar"
                                    aria-label="hotspot questions"
                                    variant="determinate"
                                    value={getPercentage(hotspotTotal)}
                                  />
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    align="right"
                                  >
                                    {hotspotTotal}
                                  </Typography>
                                </Box>
                              </Tooltip>
                            </Grid>
                          )}
                          {dragdropTotal > 0 && (
                            <Grid item xs={12} sm={6} md={4}>
                              <Tooltip title="Drag and Drop Questions">
                                <Box>
                                  <Typography variant="body2" gutterBottom>
                                    Drag and Drop
                                  </Typography>
                                  <ProgressBar
                                    role="progressbar"
                                    aria-label="drag and drop questions"
                                    variant="determinate"
                                    value={getPercentage(dragdropTotal)}
                                  />
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    align="right"
                                  >
                                    {dragdropTotal}
                                  </Typography>
                                </Box>
                              </Tooltip>
                            </Grid>
                          )}
                          {orderlistTotal > 0 && (
                            <Grid item xs={12} sm={6} md={4}>
                              <Tooltip title="OrderList Questions">
                                <Box>
                                  <Typography variant="body2" gutterBottom>
                                    OrderList
                                  </Typography>
                                  <ProgressBar
                                    role="progressbar"
                                    aria-label="orderlist questions"
                                    variant="determinate"
                                    value={getPercentage(orderlistTotal)}
                                  />
                                  <Typography
                                    variant="body2"
                                    color="text.secondary"
                                    align="right"
                                  >
                                    {orderlistTotal}
                                  </Typography>
                                </Box>
                              </Tooltip>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                    )}

                    {subject?.length > 0 && (
                      <Grid item xs={12}>
                        <Box
                          display="flex"
                          alignItems="center"
                          justifyContent="space-between"
                        >
                          <Typography
                            variant="h6"
                            component="h3"
                            fontWeight="bold"
                          >
                            Subjects Covered
                          </Typography>
                        </Box>
                        <Collapse in={showSubjects}>
                          <Grid container spacing={1} mt={1}>
                            {subject.map((sub, index) => (
                              <Grid item key={index}>
                                <Chip
                                  label={sub}
                                  sx={{
                                    backgroundColor: "rgba(39, 177, 187, 0.1)",
                                    color: "#27B1BB",
                                    fontWeight: "600",
                                    "&:hover": {
                                      backgroundColor:
                                        "rgba(39, 177, 187, 0.2)",
                                    },
                                  }}
                                />
                              </Grid>
                            ))}
                          </Grid>
                        </Collapse>
                      </Grid>
                    )}
                  </Grid>
                </CardContent>
              )}
            </StyledCard>
          )}
          <Loader open={demoLoading} />
          {showDemoQuestions && (
            <Suspense fallback={<div></div>}>
              <TargetBox
                demoExam={demoExam}
                exam={exam}
                currentQuestion={currentQuestion}
                setCurrentQuestion={setCurrentQuestion}
                selected={selected}
                setSelected={setSelected}
                show={show}
                setShow={setShow}
                correctOptions={correctOptions}
                setCorrectOptions={setCorrectOptions}
                showResults={showResults}
                setShowResults={setShowResults}
                currentQuestionRating={currentQuestionRating}
                getUserRating={getUserRating}
                availableItems={availableItems}
                setAvailableItems={setAvailableItems}
              />
            </Suspense>
          )}
          <Box
            sx={{
              color: "#505050",
              fontFamily: "Poppins",
              textAlign: "center",
              fontWeight: "400",
              fontSize: "14px",
              margin: "1rem auto",
              width: { sm: "95%", xs: "95%", md: "100%" },
            }}
            dangerouslySetInnerHTML={{ __html: getContent() }}
          />
          {sitePageContent2 && (
            <Box
              sx={{
                color: "#505050",
                fontFamily: "Poppins",
                textAlign: "center",
                fontWeight: "400",
                fontSize: "14px",
                margin: "2rem auto 0 auto",
                width: { sm: "95%", xs: "95%", md: "80%" },
              }}
              dangerouslySetInnerHTML={{
                __html: sitePageContent2
                  ? sitePageContent2
                      .replace(/\{%exam-code%\}/g, demoExam?.ExamCode)
                      .replace(/\{%exam-name%\}/g, demoExam?.ExamName)
                      .replace(/\{%category-name%\}/g, demoExam?.ExamVendorName)
                  : "",
              }}
            />
          )}
          <Suspense fallback={<div></div>}>
            <ExamDiscussion
              initialComments={initialComments}
              ExamId={demoExam?.ExamId}
              examCode={demoExam?.ExamCode}
            />
          </Suspense>
          <Toaster props={alert} onClose={alertToggle} />
        </Container>
      </Box>
    </>
  );
}

export default ExamPage;
